import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/app.png'


const _hoisted_1 = {
  class: "border-0 rounded-3 mb-4 text-center",
  style: {"background":"linear-gradient(150deg, #827cd8 0.57%, #2d2761 95.93%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"card-body p-4 text-center\"><span class=\"fs-24 d-block text-white\">Have You Tried Our</span><h3 class=\"fs-24 text-white\">New Mobile App?</h3><div class=\"py-4 mb-3\"><img src=\"" + _imports_0 + "\" alt=\"app\"></div><a href=\"#\" class=\"d-inline-block py-2 px-3 btn btn-primary\"> Download Mobile App </a></div>", 1)
  ])))
}